import { render } from "./TableGeo.vue?vue&type=template&id=0d9ad315"
import script from "./TableGeo.vue?vue&type=script&lang=js"
export * from "./TableGeo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__